import React from 'react'

import './index.css'

const Tooltip = (({label,_className,icon,text})=>(
	<div className={_className}> 
		<label>{label}</label>
		{
			icon && icon ? <i className={`fa fa-${icon}`}></i> :''
		}
		<div className="info" dangerouslySetInnerHTML={{__html: text}} />
	</div>
))

export default Tooltip


// WEBPACK FOOTER //
// ./src/Components/Tooltip/index.js